import { Link } from "@tanstack/react-router";
import { siteConfig } from "../../data/siteConfig";

type BrandLogoProps = {
  inverse?: boolean;
};

export function BrandLogo({ inverse = false }: BrandLogoProps) {
  return (
    <Link
      to="/"
      aria-label="Pastelaria Casagrande — Início"
      className={`brand-logo ${inverse ? "brand-logo--inverse" : ""}`}
    >
      {siteConfig.logoSrc ? (
        <img src={siteConfig.logoSrc} alt="Pastelaria Casagrande" className="h-12 w-auto object-contain" />
      ) : (
        <>
          <span className="brand-logo__mark" aria-hidden="true">C</span>
          <span>
            <strong>Casagrande</strong>
            <small>Pastelaria · Marinha Grande</small>
          </span>
        </>
      )}
    </Link>
  );
}
